export const ChannelsObj = {
    Direct: "Direct",
    Mail: "Email",
    OrganicSearch: "Organic Search",
    Referrals: "Referrals",
    PaidReferrals: "Display Ads",
    PaidSearch: "Paid Search",
    Social: "Social",
    InternalReferrals: "Internal Referrals",
};
